import { GetCartOptions } from '@b2x/storefront-api-js-client/src/cart';
import { ProductApiDto } from '@b2x/storefront-api-js-client/src/dto';
import React from 'react';

import { ApiRequestConfig } from './api/useApiRequest';
import { useCartApi } from './api/useCartApi';
import { useAppContext } from './AppContext';

export interface UseUpsellProductsProp extends GetCartOptions {}

export const useUpsellProducts = (options?: UseUpsellProductsProp, config?: ApiRequestConfig) => {
  const { getUpsellProducts } = useCartApi();
  const { session } = useAppContext();

  const [products, setProducts] = React.useState<Array<ProductApiDto>>();
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    setLoading(true);
    getUpsellProducts({
      populate: {
        skus: {
          price: true,
        },
        variantProducts: {
          skus: true,
        },
      },
    }).then((response) => {
      setProducts(response.data);
      setLoading(false);
    });
  }, [getUpsellProducts, session?.cart?.itemsNumber]);

  return { loading, products };
};
